import { ElementType, forwardRef, useEffect } from 'react';
import * as styles from './styles.css';
import { FormControl, InputBaseComponentProps, FormLabel, TextField } from '@mui/material';
import { IInputProps } from '.';
import InputMask from '@mona-health/react-input-mask';
import { atomFamily } from 'jotai/vanilla/utils';
import { atom } from 'jotai/vanilla';
import { useAtom } from 'jotai/react';

const MaskedBaseInput = forwardRef((props: IInputProps, ref) => {
  return <InputMask {...props} inputRef={ref} />;
});

MaskedBaseInput.displayName = 'MaskedBaseInput';

const value_atom = atomFamily(() => atom<string>(''));

const BaseInput = ({
  id,
  type,
  label,
  value: outerValue,
  onChange: handleChange,
  customTransformation,
  placeholder,
  error,
  mask,
  clearValue,
  disabled,
  onBlur,
  required,
  min,
  max,
  step,
  ...props
}: IInputProps) => {
  const [value, setValue] = useAtom(value_atom(id));

  useEffect(() => {
    if (outerValue) {
      setValue(outerValue);
    }
  }, [outerValue]);

  useEffect(() => {
    if (clearValue) {
      setValue('');
    }
  }, [clearValue]);

  const label_class = error ? styles.label_error : styles.label;
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value ?? '';
    if (customTransformation) {
      newValue = customTransformation(newValue);
    }
    setValue(newValue);
    handleChange?.(newValue);
  };
  return (
    <FormControl className={styles.input_container} variant={'standard'}>
      <FormLabel className={label_class} htmlFor={id}>
        {label}
      </FormLabel>
      <TextField
        id={id}
        type={type}
        required={required}
        className={styles.input}
        placeholder={placeholder}
        onChange={onChange}
        error={!!error}
        helperText={error}
        disabled={disabled}
        variant={'outlined'}
        value={value}
        onBlur={onBlur}
        InputProps={{
          inputComponent: MaskedBaseInput as ElementType<InputBaseComponentProps>,
          inputProps: {
            mask,
            value,
            onChange,
            max,
            min,
            step,
          },
        }}
        {...props}
      />
    </FormControl>
  );
};

export default BaseInput;
